import "./Loading.scss";
import {MoonLoader} from "react-spinners";

export default function Loading() {
    return (
        <div className="loading-wrapper"><MoonLoader className="loader" size={30}/></div>
    );
}